import { formatMoney } from "@/shared/utils/helper-functions";
import { Button, cn, Flex, Text } from "@suns/design-system";

export interface MetricButtonProps {
  label: string;
  color: string;
  currentValue: string | null;
  active?: boolean;
  onClick?: () => void;
  differenceType?: "percentage" | null;
  disabled?: boolean;
  print?: boolean;
}

export function MetricButton({
  label,
  color,
  currentValue,
  active,
  onClick,
  differenceType,
  disabled,
  print = false,
}: MetricButtonProps) {
  return (
    <Button
      variant="outline"
      className={cn(
        "h-10 rounded-md py-8",
        disabled && "pointer-events-none hover:bg-transparent"
      )}
      onClick={onClick}
      style={{
        backgroundColor: active && !disabled ? "#F0F0F0" : undefined,
      }}
    >
      <Flex direction="down" align="start" justify="start">
        <Text
          className={cn("text-md max-sm:text-sm", print && "text-sm")}
          heading
          style={{ color }}
        >
          {label}
        </Text>
        <Flex direction="right" align="end">
          <Text
            className={cn("max-sm:text-md text-lg", print && "text-xs")}
            heading
          >
            {currentValue
              ? differenceType === "percentage"
                ? formatMoney(Number(currentValue))
                : Number(currentValue).toFixed(2)
              : "--"}
          </Text>
        </Flex>
      </Flex>
    </Button>
  );
}
